import app from './feathers'
import { get } from 'svelte/store'
import { moderatorStore } from '../stores/moderatorStore'

const modService = app.service('moderators')

const methods = {
    async get() {
        const moderators = await modService.find()
        moderatorStore.set(moderators.data)
        return moderators
    },
    async create(moderator) {
        const res = await modService.create({ username: moderator })
        moderatorStore.add(res)
        return res
    },
    async remove(moderatorName) {
        const moderators = get(moderatorStore)
        const moderator = moderators.slice().find((mod) => {
            return mod.username === moderatorName
        })
        const res = await modService.remove(moderator._id)
        moderatorStore.remove(res)
        return res
    },
}

export default methods
